// // src/components/chat/ChatSidebar.jsx
// import React, { useState, useMemo, useCallback } from 'react';
// import styles from './ChatSidebar.module.css';
// import { formatLocalDate } from '../../utils/dateTime';
// import SearchInput from './SearchInput';
// import { useLazySearchAllUsersQuery } from '../../store/api/searchApi';

// export default function ChatSidebar({
//   currentUser,
//   users,
//   onSelectConversation,
//   selectedConversation,
//   viewMode = 'chat',
//   onViewModeChange,
//   pendingRequestsCount = 0,
//   chatUnreadCount = 0,   // total unread across chat conversations — always from chatUsers, never request/sent
//   onNewUserSelected,
//   isMobilePanelOpen = false,
// }) {
//   const [searchQuery, setSearchQuery] = useState('');
//   const [searchAllUsers, { currentData: allUsers = [], isLoading: searchLoading }] =
//     useLazySearchAllUsersQuery();

//   const existingChatUserIds = useMemo(
//     () => new Set(users.map((u) => u.id)),
//     [users]
//   );

//   const handleSearch = useCallback(
//     (query) => {
//       setSearchQuery(query);
//       if (query.trim().length >= 2) {
//         searchAllUsers({ query }, { preferCacheValue: false });
//       }
//     },
//     [searchAllUsers]
//   );

//   const displayUsers = useMemo(() => {
//     if (!searchQuery.trim()) return users;

//     if (viewMode === 'chat') {
//       const filteredChats = users.filter(
//         (user) =>
//           user.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           user.id?.toLowerCase().includes(searchQuery.toLowerCase())
//       );

//       const newUsers = allUsers
//         .filter((user) => !existingChatUserIds.has(user.id))
//         .map((user) => ({
//           id: user.id,
//           name: user.name,
//           profilePhotoUrl: user.profilePhotoUrl,
//           lastMessage: 'Click to start a conversation',
//           unreadCount: 0,
//           isOnline: false,
//           isNewUser: true,
//         }));

//       return [...filteredChats, ...newUsers];
//     }

//     return users.filter((user) =>
//       user.name?.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//   }, [searchQuery, users, allUsers, existingChatUserIds, viewMode]);

//   // Memoised so ConversationItem click handlers are stable
//   const handleUserClick = useCallback(
//     (user) => {
//       onSelectConversation(user.id);
//       if (user.isNewUser && onNewUserSelected) {
//         onNewUserSelected({
//           id: user.id,
//           name: user.name,
//           profilePhotoUrl: user.profilePhotoUrl,
//         });
//       }
//     },
//     [onSelectConversation, onNewUserSelected]
//   );

//   const handleTabChange = useCallback(
//     (mode) => {
//       onViewModeChange(mode);
//       setSearchQuery('');
//     },
//     [onViewModeChange]
//   );

//   // NOTE: totalUnreadCount is intentionally removed.
//   // It was derived from `users` which changes per tab — on the request tab,
//   // requestUsers each have unreadCount:1, making the chat badge show the
//   // request count instead of the actual chat unread count.
//   // The parent now passes chatUnreadCount which is always sourced from chatUsers only.

//   return (
//     <div
//       className={[styles.sidebar, isMobilePanelOpen ? styles.sidebarHidden : '']
//         .filter(Boolean)
//         .join(' ')}
//     >
//       {/* ── Current user ── */}
//       <div className={styles.profileSection}>
//         {/* {currentUser?.profilePhotoUrl ? (
//           <img
//             src={currentUser.profilePhotoUrl}
//             alt={`${currentUser.name}'s avatar`}
//             className={styles.currentUserPhoto}
//           />
//         ) : (
//           <div className={styles.avatarPlaceholder} aria-hidden="true">
//             {currentUser?.name?.charAt(0).toUpperCase() ?? '?'}
//           </div>
//         )} */}
//          {currentUser?.profilePhotoUrl ? (
//                 <img
//                   src={currentUser.profilePhotoUrl}
//                   alt={currentUser.name}
//                   className={styles.avatar}
//                 />
//               ) : (
//                 <div className={styles.noPhoto}>
//                   {currentUser.name
//                     ?.split(' ')
//                     .map((w) => w[0])
//                     .slice(0, 2)
//                     .join('')
//                     .toUpperCase() || '?'}
//                 </div>
//               )}
//         <div>
//           <h3 className={styles.currentUserName}>{currentUser?.name ?? 'You'}</h3>
//           <span className={styles.onlineStatus}>● Online</span>
//         </div>
//       </div>

//       {/* ── Tab buttons ── */}
//       <div className={styles.toggleButtons} role="tablist" aria-label="Chat sections">
//         <button
//           role="tab"
//           aria-selected={viewMode === 'chat'}
//           className={`${styles.toggleBtn} ${viewMode === 'chat' ? styles.active : ''}`}
//           onClick={() => handleTabChange('chat')}
//         >
//           <span className={styles.toggleIcon} aria-hidden="true">💬</span>
//           <span>Chats</span>
//           {chatUnreadCount > 0 && (
//             <span className={styles.badge} aria-label={`${chatUnreadCount} unread`}>
//               {chatUnreadCount > 99 ? '99+' : chatUnreadCount}
//             </span>
//           )}
//         </button>

//         <button
//           role="tab"
//           aria-selected={viewMode === 'request'}
//           className={`${styles.toggleBtn} ${viewMode === 'request' ? styles.active : ''}`}
//           onClick={() => handleTabChange('request')}
//         >
//           <span className={styles.toggleIcon} aria-hidden="true">📬</span>
//           <span>Requests</span>
//           {pendingRequestsCount > 0 && (
//             <span className={styles.badge} aria-label={`${pendingRequestsCount} pending`}>
//               {pendingRequestsCount}
//             </span>
//           )}
//         </button>

//         <button
//           role="tab"
//           aria-selected={viewMode === 'sent'}
//           className={`${styles.toggleBtn} ${viewMode === 'sent' ? styles.active : ''}`}
//           onClick={() => handleTabChange('sent')}
//         >
//           <span className={styles.toggleIcon} aria-hidden="true">📤</span>
//           <span>Sent</span>
//         </button>
//       </div>

//       {/* ── Search (chat mode only) ── */}
//       {viewMode === 'chat' && (
//         <SearchInput
//           onSearch={handleSearch}
//           placeholder="Search"
//           debounceMs={600}
//         />
//       )}

//       {/* ── Section title ── */}
//       <h2 className={styles.title}>
//         {viewMode === 'chat'
//           ? 'Messages'
//           : viewMode === 'request'
//           ? 'Pending Requests'
//           : 'Sent Requests'}
//         {searchQuery && (
//           <span className={styles.resultCount}>
//             {displayUsers.length} result{displayUsers.length !== 1 ? 's' : ''}
//           </span>
//         )}
//       </h2>

//       {/* ── Conversation list ── */}
//       <div className={styles.conversationList} role="list">
//         {searchLoading && searchQuery ? (
//           <div className={styles.loadingState} role="status" aria-live="polite">
//             <div className={styles.spinner} aria-hidden="true" />
//             <p>Searching...</p>
//           </div>
//         ) : displayUsers.length === 0 ? (
//           <div className={styles.emptyState}>
//             <div className={styles.emptyIcon} aria-hidden="true">
//               {searchQuery ? '🔍' : viewMode === 'chat' ? '💬' : '📭'}
//             </div>
//             <p>
//               {searchQuery
//                 ? `No results for "${searchQuery}"`
//                 : viewMode === 'chat'
//                 ? 'No conversations yet'
//                 : viewMode === 'request'
//                 ? 'No pending requests'
//                 : 'No sent requests'}
//             </p>
//             {!searchQuery && viewMode === 'chat' && (
//               <p className={styles.emptyHint}>Use the search box above to find users</p>
//             )}
//           </div>
//         ) : (
//           <ConversationList
//             displayUsers={displayUsers}
//             searchQuery={searchQuery}
//             viewMode={viewMode}
//             selectedConversation={selectedConversation}
//             onUserClick={handleUserClick}
//           />
//         )}
//       </div>
//     </div>
//   );
// }

// // ── Extracted list renderer for readability ──────────────────────────────────
// function ConversationList({
//   displayUsers,
//   searchQuery,
//   viewMode,
//   selectedConversation,
//   onUserClick,
// }) {
//   const existingChats = displayUsers.filter((u) => !u.isNewUser && !u.isAcceptedNew);
//   const newUsers = displayUsers.filter((u) => u.isNewUser);
//   const acceptedNew = displayUsers.filter((u) => u.isAcceptedNew);

//   // Search mode — show grouped results
//   if (searchQuery && viewMode === 'chat') {
//     return (
//       <>
//         {existingChats.length > 0 && (
//           <>
//             <div className={styles.sectionLabel}>Your Chats</div>
//             {existingChats.map((user) => (
//               <ConversationItem
//                 key={user.id}
//                 user={user}
//                 isActive={selectedConversation === user.id}
//                 onClick={() => onUserClick(user)}
//               />
//             ))}
//           </>
//         )}
//         {newUsers.length > 0 && (
//           <>
//             <div className={styles.sectionLabel}>Other Users</div>
//             {newUsers.map((user) => (
//               <ConversationItem
//                 key={user.id}
//                 user={user}
//                 isActive={false}
//                 onClick={() => onUserClick(user)}
//                 isNewUser
//               />
//             ))}
//           </>
//         )}
//       </>
//     );
//   }

//   // Default chat mode — show active chats and new connections separately
//   if (viewMode === 'chat' && !searchQuery) {
//     return (
//       <>
//         {existingChats.map((user) => (
//           <ConversationItem
//             key={user.id}
//             user={user}
//             isActive={selectedConversation === user.id}
//             onClick={() => onUserClick(user)}
//           />
//         ))}

//         {acceptedNew.length > 0 && (
//           <>
//             <div className={styles.sectionLabel}>New Connections</div>
//             {acceptedNew.map((user) => (
//               <ConversationItem
//                 key={user.id}
//                 user={user}
//                 isActive={selectedConversation === user.id}
//                 onClick={() => onUserClick(user)}
//                 isAcceptedNew
//               />
//             ))}
//           </>
//         )}
//       </>
//     );
//   }

//   // Requests / Sent tabs — flat list
//   return displayUsers.map((user) => (
//     <ConversationItem
//       key={user.id}
//       user={user}
//       isActive={selectedConversation === user.id}
//       onClick={() => onUserClick(user)}
//     />
//   ));
// }

// // ── Individual conversation row ───────────────────────────────────────────────
// function ConversationItem({
//   user,
//   isActive,
//   onClick,
//   isNewUser = false,
//   isAcceptedNew = false,
// }) {
//   const statusBadge = useMemo(() => {
//     if (user.status === undefined || user.status === null) return null;
//     const map = {
//       0: { label: 'Pending',  className: 'statusBadgePending'  },
//       1: { label: 'Accepted', className: 'statusBadgeAccepted' },
//       2: { label: 'Declined', className: 'statusBadgeDeclined' },
//     };
//     const entry = map[user.status];
//     return entry ? (
//       <span className={styles[entry.className]}>{entry.label}</span>
//     ) : null;
//   }, [user.status]);

//   const className = [
//     styles.conversationItem,
//     isActive      ? styles.active      : '',
//     isNewUser     ? styles.newUser     : '',
//     isAcceptedNew ? styles.acceptedNew : '',
//   ]
//     .filter(Boolean)
//     .join(' ');

//   return (
//     <div
//       className={className}
//       onClick={onClick}
//       role="listitem button"
//       tabIndex={0}
//       onKeyDown={(e) => e.key === 'Enter' && onClick()}
//       aria-current={isActive ? 'true' : undefined}
//     >
//       {user.profilePhotoUrl ? (
//         <img
//           src={user.profilePhotoUrl}
//           alt={`${user.name}'s avatar`}
//           className={styles.userPhoto}
//         />
//       ) : (
//         <div className={styles.avatarPlaceholder} aria-hidden="true">
//           {user.name?.charAt(0).toUpperCase() ?? '?'}
//         </div>
//       )}

//       <div className={styles.conversationContent}>
//         <h4 className={styles.userName}>
//           {user.name}
//           {isNewUser && <span className={styles.newBadge}>New</span>}
//           {isAcceptedNew && <span className={styles.acceptedBadge}>Say Hi 👋</span>}
//         </h4>
//         <p className={styles.lastMessage}>
//           {user.lastMessage || 'Click to start a conversation'}
//         </p>
//       </div>

//       {statusBadge ?? (
//         !isNewUser && (
//           <>
//             {user.unreadCount > 0 ? (
//               <span className={styles.unreadBadge} aria-label={`${user.unreadCount} unread`}>
//                 {user.unreadCount}
//               </span>
//             ) : user.lastSentAt ? (
//               <span className={styles.time}>{formatLocalDate(user.lastSentAt)}</span>
//             ) : null}
//           </>
//         )
//       )}
//     </div>
//   );
// }

// src/components/chat/ChatSidebar.jsx
import React, { useState, useMemo, useCallback } from 'react';
import styles from './ChatSidebar.module.css';
import { formatLocalDate } from '../../utils/dateTime';
import SearchInput from './SearchInput';
import { useLazySearchAllUsersQuery } from '../../store/api/searchApi';

export default function ChatSidebar({
  currentUser,
  users,
  onSelectConversation,
  selectedConversation,
  viewMode = 'chat',
  onViewModeChange,
  pendingRequestsCount = 0,
  chatUnreadCount = 0,   // total unread across chat conversations — always from chatUsers, never request/sent
  onNewUserSelected,
  isMobilePanelOpen = false,
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchAllUsers, { currentData: allUsers = [], isLoading: searchLoading }] =
    useLazySearchAllUsersQuery();

  const existingChatUserIds = useMemo(
    () => new Set(users.map((u) => u.id)),
    [users]
  );

  const handleSearch = useCallback(
    (query) => {
      setSearchQuery(query);
      if (query.trim().length >= 2) {
        searchAllUsers({ query }, { preferCacheValue: false });
      }
    },
    [searchAllUsers]
  );

  const displayUsers = useMemo(() => {
    if (!searchQuery.trim()) return users;

    if (viewMode === 'chat') {
      const filteredChats = users.filter(
        (user) =>
          user.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.id?.toLowerCase().includes(searchQuery.toLowerCase())
      );

      const newUsers = allUsers
        .filter((user) => !existingChatUserIds.has(user.id))
        .map((user) => ({
          id: user.id,
          name: user.name,
          profilePhotoUrl: user.profilePhotoUrl,
          lastMessage: 'Click to start a conversation',
          unreadCount: 0,
          isOnline: false,
          isNewUser: true,
        }));

      return [...filteredChats, ...newUsers];
    }

    return users.filter((user) =>
      user.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [searchQuery, users, allUsers, existingChatUserIds, viewMode]);

  // Memoised so ConversationItem click handlers are stable
  const handleUserClick = useCallback(
    (user) => {
      if (user.isNewUser && onNewUserSelected) {
        onNewUserSelected({
          id: user.id,
          name: user.name,
          profilePhotoUrl: user.profilePhotoUrl,
        });
      }
      onSelectConversation(user.id);
    },
    [onSelectConversation, onNewUserSelected]
  );

  const handleTabChange = useCallback(
    (mode) => {
      onViewModeChange(mode);
      setSearchQuery('');
    },
    [onViewModeChange]
  );

  // NOTE: totalUnreadCount is intentionally removed.
  // It was derived from `users` which changes per tab — on the request tab,
  // requestUsers each have unreadCount:1, making the chat badge show the
  // request count instead of the actual chat unread count.
  // The parent now passes chatUnreadCount which is always sourced from chatUsers only.

  return (
    <div
      className={[styles.sidebar, isMobilePanelOpen ? styles.sidebarHidden : '']
        .filter(Boolean)
        .join(' ')}
    >
      {/* ── Current user ── */}
      <div className={styles.profileSection}>
        {/* {currentUser?.profilePhotoUrl ? (
          <img
            src={currentUser.profilePhotoUrl}
            alt={`${currentUser.name}'s avatar`}
            className={styles.currentUserPhoto}
          />
        ) : (
          <div className={styles.avatarPlaceholder} aria-hidden="true">
            {currentUser?.name?.charAt(0).toUpperCase() ?? '?'}
          </div>
        )} */}
         {currentUser?.profilePhotoUrl ? (
                <img
                  src={currentUser.profilePhotoUrl}
                  alt={currentUser.name}
                  className={styles.avatar}
                />
              ) : (
                <div className={styles.noPhoto}>
                  {currentUser.name
                    ?.split(' ')
                    .map((w) => w[0])
                    .slice(0, 2)
                    .join('')
                    .toUpperCase() || '?'}
                </div>
              )}
        <div>
          <h3 className={styles.currentUserName}>{currentUser?.name ?? 'You'}</h3>
          <span className={styles.onlineStatus}>● Online</span>
        </div>
      </div>

      {/* ── Tab buttons ── */}
      <div className={styles.toggleButtons} role="tablist" aria-label="Chat sections">
        <button
          role="tab"
          aria-selected={viewMode === 'chat'}
          className={`${styles.toggleBtn} ${viewMode === 'chat' ? styles.active : ''}`}
          onClick={() => handleTabChange('chat')}
        >
          <span className={styles.toggleIcon} aria-hidden="true">💬</span>
          <span>Chats</span>
          {chatUnreadCount > 0 && (
            <span className={styles.badge} aria-label={`${chatUnreadCount} unread`}>
              {chatUnreadCount > 99 ? '99+' : chatUnreadCount}
            </span>
          )}
        </button>

        <button
          role="tab"
          aria-selected={viewMode === 'request'}
          className={`${styles.toggleBtn} ${viewMode === 'request' ? styles.active : ''}`}
          onClick={() => handleTabChange('request')}
        >
          <span className={styles.toggleIcon} aria-hidden="true">📬</span>
          <span>Requests</span>
          {pendingRequestsCount > 0 && (
            <span className={styles.badge} aria-label={`${pendingRequestsCount} pending`}>
              {pendingRequestsCount}
            </span>
          )}
        </button>

        <button
          role="tab"
          aria-selected={viewMode === 'sent'}
          className={`${styles.toggleBtn} ${viewMode === 'sent' ? styles.active : ''}`}
          onClick={() => handleTabChange('sent')}
        >
          <span className={styles.toggleIcon} aria-hidden="true">📤</span>
          <span>Sent</span>
        </button>
      </div>

      {/* ── Search (chat mode only) ── */}
      {viewMode === 'chat' && (
        <SearchInput
          onSearch={handleSearch}
          placeholder="Search"
          debounceMs={600}
        />
      )}

      {/* ── Section title ── */}
      <h2 className={styles.title}>
        {viewMode === 'chat'
          ? 'Messages'
          : viewMode === 'request'
          ? 'Pending Requests'
          : 'Sent Requests'}
        {searchQuery && (
          <span className={styles.resultCount}>
            {displayUsers.length} result{displayUsers.length !== 1 ? 's' : ''}
          </span>
        )}
      </h2>

      {/* ── Conversation list ── */}
      <div className={styles.conversationList} role="list">
        {searchLoading && searchQuery ? (
          <div className={styles.loadingState} role="status" aria-live="polite">
            <div className={styles.spinner} aria-hidden="true" />
            <p>Searching...</p>
          </div>
        ) : displayUsers.length === 0 ? (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon} aria-hidden="true">
              {searchQuery ? '🔍' : viewMode === 'chat' ? '💬' : '📭'}
            </div>
            <p>
              {searchQuery
                ? `No results for "${searchQuery}"`
                : viewMode === 'chat'
                ? 'No conversations yet'
                : viewMode === 'request'
                ? 'No pending requests'
                : 'No sent requests'}
            </p>
            {!searchQuery && viewMode === 'chat' && (
              <p className={styles.emptyHint}>Use the search box above to find users</p>
            )}
          </div>
        ) : (
          <ConversationList
            displayUsers={displayUsers}
            searchQuery={searchQuery}
            viewMode={viewMode}
            selectedConversation={selectedConversation}
            onUserClick={handleUserClick}
          />
        )}
      </div>
    </div>
  );
}

// ── Extracted list renderer for readability ──────────────────────────────────
function ConversationList({
  displayUsers,
  searchQuery,
  viewMode,
  selectedConversation,
  onUserClick,
}) {
  const existingChats = displayUsers.filter((u) => !u.isNewUser && !u.isAcceptedNew);
  const newUsers = displayUsers.filter((u) => u.isNewUser);
  const acceptedNew = displayUsers.filter((u) => u.isAcceptedNew);

  // Search mode — show grouped results
  if (searchQuery && viewMode === 'chat') {
    return (
      <>
        {existingChats.length > 0 && (
          <>
            <div className={styles.sectionLabel}>Your Chats</div>
            {existingChats.map((user) => (
              <ConversationItem
                key={user.id}
                user={user}
                isActive={selectedConversation === user.id}
                onClick={() => onUserClick(user)}
              />
            ))}
          </>
        )}
        {newUsers.length > 0 && (
          <>
            <div className={styles.sectionLabel}>Other Users</div>
            {newUsers.map((user) => (
              <ConversationItem
                key={user.id}
                user={user}
                isActive={false}
                onClick={() => onUserClick(user)}
                isNewUser
              />
            ))}
          </>
        )}
      </>
    );
  }

  // Default chat mode — show active chats and new connections separately
  if (viewMode === 'chat' && !searchQuery) {
    return (
      <>
        {existingChats.map((user) => (
          <ConversationItem
            key={user.id}
            user={user}
            isActive={selectedConversation === user.id}
            onClick={() => onUserClick(user)}
          />
        ))}

        {acceptedNew.length > 0 && (
          <>
            <div className={styles.sectionLabel}>New Connections</div>
            {acceptedNew.map((user) => (
              <ConversationItem
                key={user.id}
                user={user}
                isActive={selectedConversation === user.id}
                onClick={() => onUserClick(user)}
                isAcceptedNew
              />
            ))}
          </>
        )}
      </>
    );
  }

  // Requests / Sent tabs — flat list
  return displayUsers.map((user) => (
    <ConversationItem
      key={user.id}
      user={user}
      isActive={selectedConversation === user.id}
      onClick={() => onUserClick(user)}
    />
  ));
}

// ── Individual conversation row ───────────────────────────────────────────────
function ConversationItem({
  user,
  isActive,
  onClick,
  isNewUser = false,
  isAcceptedNew = false,
}) {
  const statusBadge = useMemo(() => {
    if (user.status === undefined || user.status === null) return null;
    const map = {
      0: { label: 'Pending',  className: 'statusBadgePending'  },
      1: { label: 'Accepted', className: 'statusBadgeAccepted' },
      2: { label: 'Declined', className: 'statusBadgeDeclined' },
    };
    const entry = map[user.status];
    return entry ? (
      <span className={styles[entry.className]}>{entry.label}</span>
    ) : null;
  }, [user.status]);

  const className = [
    styles.conversationItem,
    isActive      ? styles.active      : '',
    isNewUser     ? styles.newUser     : '',
    isAcceptedNew ? styles.acceptedNew : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={className}
      onClick={onClick}
      role="listitem button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      aria-current={isActive ? 'true' : undefined}
    >
      {user.profilePhotoUrl ? (
        <img
          src={user.profilePhotoUrl}
          alt={`${user.name}'s avatar`}
          className={styles.userPhoto}
        />
      ) : user.name === 'Nessefy Official' ? (
        <div aria-hidden="true" style={{
          width:44,height:44,borderRadius:'50%',flexShrink:0,
          background:'linear-gradient(135deg,#014d6e,#016d9c)',
          display:'flex',alignItems:'center',justifyContent:'center',
          border:'2px solid #cde4ef',
          fontFamily:'Sora,sans-serif',fontSize:'0.85rem',
          fontWeight:800,color:'#fff',letterSpacing:'0.04em'
        }}>
          N
        </div>
      ) : (
        <div className={styles.avatarPlaceholder} aria-hidden="true">
          {user.name?.charAt(0).toUpperCase() ?? '?'}
        </div>
      )}

      <div className={styles.conversationContent}>
        <h4 className={styles.userName}>
          {user.name}
          {/* Nessefy Official verified badge */}
          {user.name === 'Nessefy Official' && (
            <span style={{
              display:'inline-flex',alignItems:'center',gap:2,
              background:'linear-gradient(135deg,#014d6e,#016d9c)',
              color:'#fff',fontSize:'0.58rem',fontWeight:700,
              padding:'1px 6px',borderRadius:8,marginLeft:4,
              fontFamily:'Sora,sans-serif',letterSpacing:'0.02em'
            }}>
              ✓ Official
            </span>
          )}
          {isNewUser && <span className={styles.newBadge}>New</span>}
          {isAcceptedNew && <span className={styles.acceptedBadge}>Say Hi 👋</span>}
        </h4>
        <p className={styles.lastMessage}>
          {user.lastMessage || 'Click to start a conversation'}
        </p>
      </div>

      {statusBadge ?? (
        !isNewUser && (
          <>
            {user.unreadCount > 0 ? (
              <span className={styles.unreadBadge} aria-label={`${user.unreadCount} unread`}>
                {user.unreadCount}
              </span>
            ) : user.lastSentAt ? (
              <span className={styles.time}>{formatLocalDate(user.lastSentAt)}</span>
            ) : null}
          </>
        )
      )}
    </div>
  );
}